export default "__VITE_ASSET__0f3fd856__"